module.exports = __webpack_public_path__ + "media/fonts/suisse-intl/SuisseIntl-LightItalic-WebS-22e9d8c2be96b4c08fc36c2703ebb557.woff2";